import { useContext, useEffect, useState } from "react";
import DynamicGrid from "../../Components/DynamicGrid/DynamicGrid";
import { Button, Tooltip, Typography } from "@mui/material";
import { LoaderContext, getContext } from "../../Helpers/Context/Context";
import { APICall } from "../../Helpers/Network/APICalls";
import {
  GetYojnaStatmentDashboardDetails,
  GetYojnaStatmentExportToExcel,
  GetSuvidhaYojnaStatmentExportToExcel,
  InsertRenewalYojna,
  ClosedSanjeevaniYojna_FD,
  DownloadsanjeevaniReceiptData,
  DownloadsuvidhaReceiptData,
  getConfigValues,
  DownloadSanjeevaniApplicationForm,
  DownloadSuvidhaApplicationForm,
} from "../../Helpers/APIEndPoints/EndPoints";
import OverflowTip from "../../Components/OverflowToolTip/OverflowToolTip";
import moment from "moment";
import {
  ApiErrorMsg,
  DATE_DISPLAY_FORMAT,
} from "../../Helpers/Constants/Constants";
import notify, { ToastType } from "../../Helpers/ToastNotification";

import DateForm from "../../Components/DateForm/DateForm";
import axios from "axios";
import fileDownload from "js-file-download";
import { fetchAuthToken } from "../../Helpers/Network/OAuthHandler";
import "./Sanjeevani.css";
import { AppModules } from "../../Helpers/Enums/AppModules";
import { ApiStatus } from "../../Helpers/Enums/ApiStatus";
import CustomModal from "../../Components/Modal/CustomModal";
const DepositeStatementGrid = (props) => {
  const {
    activeTab,
    // tab1,
    // searchText,
    // setSearchText,
    // dataCount,
    // setDataCount,
    // setCurrentDataReqObj,
    // selectNextTab,
    // selectPreviousTab,
  } = props;
  const { appModule } = props;
  const [pageSize] = useState(10);
  const [start, setStart] = useState(0);
  const [sortColumn, setSortColumn] = useState("");
  const [sortDirection, setSortDirection] = useState("");
  const context = getContext();
  const [dashboardData, setDashboardData] = useState([]);
  const { showLoader, hideLoader } = useContext(LoaderContext);
  const [toDate, setToDate] = useState(null);
  const [fromDate, setFromDate] = useState(null);
  const [currentFilters, setCurrentFilters] = useState(null);
  const [currentDataReqObj, setCurrentDataReqObj] = useState(null);
  const [dataCount, setDataCount] = useState(0);
  const [searchText, setSearchText] = useState("");
  const [modalOpen, setModalOpen] = useState(false);
  let MemberId = context.MemberId;
  const [dashData, setDashData] = useState({
    memberNum: null,
    TotalAWI: null,
    amount: null,
    DOJ: null,
    Unit: null,
    ROI: 0,
  });
  const [submitMsg, setSubmitMsg] = useState("");
  const [smtId, setSmtId] = useState(0);
  const [transRefNo, setTransRefNo] = useState(0);
  const [selectedReqId, setSelectedReqId] = useState(0);
  const [selectedMemId, setSelectedMemId] = useState(0);
  const enum EventTarget {
    FromDateOnChange,
    ToDateOnChange,
    Reset,
    Apply,
    ExportToExcelClick,
  }
  const [renewalType, setRenewalType] = useState(false);

  useEffect(() => {
    if (activeTab != null) {
      // callConfigData();
      getDashboardData();
    }
  }, [activeTab, start, sortColumn, sortDirection, currentFilters]);

  const getDashboardData = async () => {
    showLoader();
    try {
      let obj = {
        start: start,
        resultsPerPage: pageSize,
        searchText: searchText,
        sortColumn: sortColumn,
        sortDirection: sortDirection,
        FromDate: currentFilters?.fromDate || "",
        ToDate: currentFilters?.toDate || "",
        YojnaType:
          appModule === AppModules.SuvidhaYojna
            ? "SuvidhaYojna"
            : "SanjivaniYojna",
        MemberId: MemberId,
      };
      // setCurrentDataReqObj(obj);
      const resp = await APICall(GetYojnaStatmentDashboardDetails, obj);
      const headerData = resp?.Data;

      setDashData({
        ...headerData,
        memberNum: headerData.MemberNumber,
        TotalAWI: headerData.TotalAmountWithInterest,
        amount: headerData.Amount,
        DOJ: headerData.DOJ,
        Unit: headerData.Unit,
        ROI: headerData.RateOfIntrest,
      });

      // const listData = resp?.Data.SNJY_StatmentDashboardList;
      // let foundReqId = null;
      // let foundSmtId = null;
      // let foundMemberId = null;

      // listData.forEach((item) => {
      //   foundReqId = item.RequestId;
      //   foundMemberId = item.MemberId;

      //   if (item.IsWithinOneYearOrFiveDays === true) {
      //     foundReqId = item.RequestId;
      //     foundSmtId = item.Id;
      //     return;
      //   }
      // });
      // setReqId(foundReqId);
      // setSmtId(foundSmtId);
      // setFoundMemId(foundMemberId);
      // setSmtId(headerData.Id);

      if (resp.Data.SNJY_StatmentDashboardList.length > 0) {
        setDashboardData(resp?.Data.SNJY_StatmentDashboardList);
        const dataCount1 = resp?.Data?.SNJY_StatmentDashboardList[0].TotalCount;
        setDataCount(dataCount1);
        // setCurrentDataReqObj(obj);
        // selectNextTab();
      } else if (resp.Data.SNJY_StatmentDashboardList.length == 0) {
        setDashboardData([]);
        setDataCount(0);
      } else if (resp.Message === "Something Went Wrong.") {
        notify(1, `${resp.Message}`);
        setDashboardData([]);
        setDataCount(0);
      }
    } catch (err) {
      notify(
        ToastType.Error,
        // "Oops! Something went wrong. We're on it. Please try again later."
        ApiErrorMsg
      );
    } finally {
      hideLoader();
    }
  };

  const callConfigData = async () => {
    const config = ["RenewalSANMsg"];

    const result = await APICall(getConfigValues, { Keys: config });
    if (result && result.Message == "Ok" && result.Data.length > 0) {
      result.Data.map((cd) => {
        if (cd.Key === "RenewalSANMsg") {
          //need to add key msg in config
          setSubmitMsg("RenewalSANMsg");
        }
      });
    }
  };

  const handleCloseModal = () => {
    setModalOpen(false);
  };

  const handleYesFunctionality = (isRenewal) => {
    if (isRenewal) {
      RenewalAmt(true);
    } else {
      RenewalAmt(false);
    }
    setModalOpen(false);
  };

  // Insert or close RenewalYojna
  const RenewalAmt = async (isRenewal) => {
    showLoader();

    try {
      let obj = {
        MemberId: selectedMemId,
        RequestId: selectedReqId,
        Id: smtId,
        YojnaType: "SanjivaniYojna",
        CreatedBy: context.Id,
        // TransactionReferenceNo: transRefNo,
      };
      const api = isRenewal ? InsertRenewalYojna : ClosedSanjeevaniYojna_FD;
      const message = isRenewal
        ? "Your amount is renewal in 2-3 days"
        : "Your renewal request has been closed successfully";
      const resp = await APICall(api, obj);
      if (resp.Message === "Success") {
        notify(0, message);
        getDashboardData();
      } else if (resp.Status === ApiStatus.Error) {
        notify(1, resp.Message);
        getDashboardData();
      } else if (resp.Message === "NOT FOUND") {
        notify(1, "Data not found");
      }
    } catch (err) {
      notify(
        ToastType.Error,
        "Oops! Something went wrong. We're on it. Please try again later."
      );
      // console.log("Your amount is not renewal.");
    } finally {
      hideLoader();
    }
  };

  const CustomCellComponent = (
    value: any,
    tableMeta: any,
    isDate: boolean = false
  ) => {
    return (
      <>
        <OverflowTip>
          <Typography
            fontFamily={"Georama-Regular, sans-serif"}
            fontSize={"14px"}
            component={"span"}
            noWrap={true}
          >
            {!isDate
              ? value
              : value
              ? moment(value).format(DATE_DISPLAY_FORMAT)
              : ""}
          </Typography>
        </OverflowTip>
      </>
    );
  };

  const CommonCellOptions = (isDate: boolean = false) => {
    return {
      filter: true,
      sort: true,
      sortDescFirst: true,
      customBodyRender: (value, tableMeta) =>
        CustomCellComponent(value, tableMeta, isDate),
    };
  };

  //   showLoader();
  //   let requestParams = { Id: id };
  //   let token = await fetchAuthToken();
  //   axios
  //     .request({
  //       responseType: "blob",
  //       method: "POST",
  //       url:
  //         appModule === AppModules.SanjeevaniYojana
  //           ? DownloadsanjeevaniReceiptData
  //           : DownloadsuvidhaReceiptData,
  //       data: requestParams,
  //       headers: {
  //         "Access-Control-Allow-Origin": "*",
  //         "Content-Type": "application/json",
  //         "Access-Control-Allow-Headers": "*",
  //         Authorization: `Bearer ${token}`,
  //       },
  //     })
  //     .then((response) => {
  //       fileDownload(
  //         response.data,
  //         `SanjeevaniPaymentReceipt_` +
  //           `${moment(new Date()).format(moment.HTML5_FMT.DATE)}` +
  //           `.pdf`
  //       );
  //       hideLoader();
  //     })
  //     .catch((error) => {
  //       hideLoader();
  //       notify(1, error);
  //       console.log(error);
  //     });
  // };

  const downloadStatmentPdf = async (requestIdFromList, memberIdFromList) => {
    showLoader();
    let requestParams = {
      MemberId: memberIdFromList,
      RequestId: requestIdFromList,
      // RequestId: 375,
    };
    let token = await fetchAuthToken();
    let fileNamePrefix = "";
    if (appModule === AppModules.SanjeevaniYojana) {
      fileNamePrefix = "SanjivaniPaymentReceipt_";
    } else if (appModule === AppModules.SuvidhaYojna) {
      fileNamePrefix = "SuvidhaPaymentReceipt_";
    }
    axios
      .request({
        responseType: "blob",
        method: "POST",
        url:
          appModule === AppModules.SanjeevaniYojana
            ? DownloadsanjeevaniReceiptData
            : DownloadsuvidhaReceiptData,
        data: requestParams,
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
          "Access-Control-Allow-Headers": "*",
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        fileDownload(
          response.data,
          `${fileNamePrefix}${moment(new Date()).format(
            moment.HTML5_FMT.DATE
          )}.pdf`
        );

        hideLoader();
      })
      .catch((error) => {
        hideLoader();
        notify(
          1,
          "Oops! Something went wrong. We're on it. Please try again later."
        );
       
      });
  };

  const downloadDynForm = async (requestIdFromList, memberIdFromList) => {
    showLoader();
    let requestParams = {
      MemberId: memberIdFromList,
      RequestId: requestIdFromList,
    };
    let token = await fetchAuthToken();
    let fileNamePrefix = "";
    if (appModule === AppModules.SanjeevaniYojana) {
      fileNamePrefix = "SanjivaniForm_";
    } else if (appModule === AppModules.SuvidhaYojna) {
      fileNamePrefix = "SuvidhaForm_";
    }
    axios
      .request({
        responseType: "blob",
        method: "POST",
        url:
          appModule === AppModules.SanjeevaniYojana
            ? DownloadSanjeevaniApplicationForm
            : DownloadSuvidhaApplicationForm,
        data: requestParams,
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
          "Access-Control-Allow-Headers": "*",
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        fileDownload(
          response.data,
          `${fileNamePrefix}${moment(new Date()).format(
            moment.HTML5_FMT.DATE
          )}.pdf`
        );

        hideLoader();
      })
      .catch((error) => {
        hideLoader();
        notify(
          1,
          "Oops! Something went wrong. We're on it. Please try again later."
        );
       
      });
  };

  const GridColumns = [
    //0  Id
    {
      name: "Id",
      label: "Id",
      options: {
        display: false,
      },
    },
    //1 StatusId
    {
      name: "StatusId",
      label: "StatusId",
      options: {
        display: false,
      },
    },
    //2 Transactiondate
    {
      name: "Transactiondate",
      label: "Transaction Date",
      options: {
        ...CommonCellOptions(true),
        display: true,
      },
    },
    //3 Amount
    {
      name: "Amount",
      label: "Amount",
      options: {
        // ...CommonCellOptions(false),
        display: true,
        customBodyRender: (value, tableMeta) => {
          const StatmentStateColor = tableMeta.rowData[8];
          let textColor = "black";
          if (StatmentStateColor === "green") {
            textColor = "green";
          } else if (StatmentStateColor === "red") {
            textColor = "red";
          }

          return (
            <Typography
              style={{ color: textColor }}
              fontFamily={"Georama-Regular, sans-serif"}
              fontSize={"14px"}
              component={"span"}
              noWrap={true}
            >
              {tableMeta.rowData[3]}
            </Typography>
          );
        },
      },
    },
    //4 DocumentNumber
    {
      name: "DocumentNumber",
      label: "Document Number",
      options: {
        display: true,
      },
    },
    //5 Payment reference Number (TransactionReferenceNo )
    {
      name: "TransactionReferenceNo",
      label: "Payment reference Number",
      options: {
        ...CommonCellOptions(),
        display: true,
      },
    },
    //6 Status
    {
      name: "Status",
      label: "Status",
      options: {
        display: true,
      },
    },
    //7 Transaction Type
    {
      name: "Action",
      label: "Transaction Type",
      options: {
        display: true,
      },
    },
    //8 StatmentStateColor
    {
      name: "StatmentStateColor",
      label: "StatmentStateColor",
      options: {
        display: false,
      },
    },
    //9 IsWithinOneYearOrFiveDays
    {
      name: "IsWithinOneYearOrFiveDays",
      label: "Action",
      options: {
        // display: appModule === AppModules.SanjeevaniYojana,
        customBodyRender: (value, tableMeta) => {
          
          const statusIndex = tableMeta.rowData[6];
          const requestIdFromList = tableMeta.rowData[10];
          const memberIdFromList = tableMeta.rowData[11];
          const statmentIdFromList = tableMeta.rowData[0];
          const TransactionRefFromList = tableMeta.rowData[5];
          const IsWithinOneYearOrFiveDaysFromList = tableMeta.rowData[9];
          return (
            <>
              <div className="d-flex justify-content-right align-items-center">
                {statusIndex === "Deposit Approved" && (
                  <>
                    <div className="d-flex justify-content-right align-items-center">
                      <Tooltip title="Receipt">
                        <a
                          onClick={() =>
                            downloadStatmentPdf(
                              requestIdFromList,
                              memberIdFromList
                            )
                          }
                        >
                          <i className="fas fa-file-download"></i>
                        </a>
                      </Tooltip>

                      <Tooltip title="Application Form" className="ml-3">
                        <a
                          onClick={() =>
                            downloadDynForm(requestIdFromList, memberIdFromList)
                          }
                        >
                          <i className="far fa-file-archive"></i>
                        </a>
                      </Tooltip>
                    </div>
                  </>
                )}
                {IsWithinOneYearOrFiveDaysFromList === true &&
                  statusIndex === "Deposit Approved" && (
                    <>
                      <CustomModal
                        show2={modalOpen}
                        handleClose2={handleCloseModal}
                        onHide2={() => setModalOpen(false)}
                        title="Are you sure"
                        body={
                          renewalType
                            ? "Are you sure to renew amount?"
                            : "Are you sure to settle your amount?"
                        }
                        hideButton1={false}
                        buttonLabel1="Yes"
                        handleYesFunctionality={() => {
                          handleYesFunctionality(renewalType);
                        }}
                        buttonLabel2="No"
                        hideButton2={false}
                      />
                      <div className="d-flex justify-content-right align-items-center">
                        <Tooltip
                          title="Renewal"
                          className="ml-3"
                          style={{ cursor: "pointer" }}
                        >
                          <i
                            className="fas fa-sync"
                            onClick={() => {
                              setRenewalType(true);
                              setModalOpen(true);
                              setSelectedReqId(requestIdFromList);
                              setSelectedMemId(memberIdFromList);
                              setSmtId(statmentIdFromList);
                              setTransRefNo(TransactionRefFromList);
                            }}
                          ></i>
                        </Tooltip>
                        <Tooltip
                          title="Settlement"
                          className="ml-3"
                          style={{ cursor: "pointer" }}
                        >
                          <i
                            className="far fa-times-circle"
                            onClick={() => {
                              setModalOpen(true);
                              setRenewalType(false);
                              setSelectedReqId(requestIdFromList);
                              setSelectedMemId(memberIdFromList);
                              setSmtId(statmentIdFromList);
                            }}
                          ></i>
                        </Tooltip>
                      </div>
                    </>
                  )}
              </div>
            </>
          );
        },
      },
    },
    //10 RequestId
    {
      name: "RequestId",
      label: "RequestId",
      options: {
        ...CommonCellOptions(),
        display: false,
      },
    },
    //11 MemberId
    {
      name: "MemberId",
      label: "MemberId",
      options: {
        ...CommonCellOptions(),
        display: false,
      },
    },
  ];

  const Options = {
    showEmptyDataSourceMessage: true,
    selectableRows: "none",
    count: dataCount,
    rowsPerPage: pageSize,
    serverSide: true,
    rowsPerPageOptions: [],
    download: false,
    print: false,
    viewColumns: false,
    filter: false,
    search: false,
    responsive: "standard",
    onChangeRowsPerPage: () => {},
    onSearchChange: (searchText) => {
      if (searchText !== null) {
        setSearchText(searchText);
      } else {
        setSearchText("");
      }
      setStart(0);
    },
    onColumnSortChange: async (sortColumn, sortDirection) => {
      if (sortDirection === "asc") {
        setSortColumn(sortColumn);
        setSortDirection(sortDirection);
      }
      if (sortDirection === "desc") {
        setSortColumn(sortColumn);
        setSortDirection(sortDirection);
      }
      setStart(0);
    },
    onChangePage: async (page) => {
      setStart(page * pageSize);
    },
  };

  const ExportToExcel = async () => {
    let obj = {
      start: start,
      resultsPerPage: pageSize,
      searchText: searchText,
      sortColumn: sortColumn,
      sortDirection: sortDirection,
      FromDate: currentFilters?.fromDate || "",
      ToDate: currentFilters?.toDate || "",
      YojnaType:
        appModule === AppModules.SuvidhaYojna
          ? "SuvidhaYojna"
          : "SanjivaniYojna",
      MemberId: MemberId,
    };
    let token = await fetchAuthToken();
    axios
      .request({
        responseType: "blob",
        method: "POST",
        url:
          appModule === AppModules.SuvidhaYojna
            ? GetSuvidhaYojnaStatmentExportToExcel
            : GetYojnaStatmentExportToExcel,
        data: obj,
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
          "Access-Control-Allow-Headers": "*",
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
       
        fileDownload(
          response.data,
          `${
            appModule === AppModules.SuvidhaYojna ? "Suvidha" : "Sanjivani"
          }Statment_` +
            `${moment(new Date()).format(moment.HTML5_FMT.DATE)}` +
            `.xlsx`
        );
      })
      .catch((error) => {
     
        notify(ToastType.Error, "Failed to export data.");
      });
  };

  const handleEvents = (target: EventTarget, event: any = null) => {
    switch (target) {
      case EventTarget.FromDateOnChange:
        setFromDate(event ? moment(event).format("YYYY-MM-DD") : null);
        break;
      case EventTarget.ToDateOnChange:
        if (fromDate && event && moment(event).isBefore(moment(fromDate))) {
          notify(1, "To date should be greater than From date");
        } else {
          setToDate(event ? moment(event).format("YYYY-MM-DD") : null);
        }
        // setToDate(event ? moment(event).format("YYYY-MM-DD") : null);
        break;
      case EventTarget.Reset:
        setFromDate(null);
        setToDate(null);
        const filtersReset = {
          fromDate: null,
          toDate: null,
        };
        setCurrentFilters(filtersReset);
        break;
      case EventTarget.Apply:
        if (fromDate && toDate && moment(toDate).isBefore(moment(fromDate))) {
          notify(1, "To date should be greater than or equal to From date");
        } else {
          const filtersApply = {
            fromDate: fromDate ? moment(fromDate).format("YYYY-MM-DD") : null,
            toDate: toDate ? moment(toDate).format("YYYY-MM-DD") : null,
          };
          setCurrentFilters(filtersApply);
        }
        break;
      case EventTarget.ExportToExcelClick:
        if (dataCount === 0) {
          notify(ToastType.Error, "No data available");
        } else {
          ExportToExcel();
        }
        break;
    }
  };

  return (
    <>
      <div className="row">
        {/* Member number */}
        <div className="col-lg-3 col-md-4">
          <div className="form-group ">
            <p>
              <span className="font-weight-bold"> Member number : </span>{" "}
              {dashData.memberNum}
            </p>
          </div>
        </div>
        {/* Unit code */}
        <div className="col-lg-3 col-md-4">
          <div className="form-group ">
            <p>
              {" "}
              <span className="font-weight-bold">Unit : </span>
              {dashData.Unit}
            </p>
          </div>
        </div>
        {/* FD amount */}
        <div className="col-lg-3 col-md-4">
          <div className="form-group ">
            <p>
              <span className="font-weight-bold">FD Amount : </span>{" "}
              {dashData.amount}
            </p>
          </div>
        </div>
        {/* Date of Joining */}
        <div className="col-lg-3 col-md-4">
          <div className="form-group">
            <p>
              <span className="font-weight-bold">Date of Joining : </span>
              {moment(dashData.DOJ).format(DATE_DISPLAY_FORMAT)}
            </p>
          </div>
        </div>
        {/* Available Balance */}
        <div className="col-lg-5 col-md-6">
          <div className="form-group ">
            {appModule === AppModules.SanjeevaniYojana && (
              <p>
                <span className="font-weight-bold">
                  Additional investment available for Sanjivani FD :
                </span>{" "}
                {300000 - dashData.amount}
              </p>
            )}

            {appModule === AppModules.SuvidhaYojna && (
              <p>
                <span className="font-weight-bold">
                  Additional investment available for Suvidha FD :
                </span>{" "}
                {50000 - dashData.amount}
              </p>
            )}
          </div>
        </div>
      </div>

      {/* ------------  Filters ------------*/}
      <div className="filter-content">
        <div className="row " style={{ marginTop: "-10px", padding: "15px" }}>
          <div className="col-lg-3 col-sm-3 col-xs-12 mb-2 pl-1">
            <div className="form-group">
              <label>From Date</label>
              <br />
              <div className="">
                <div className="input-group date selectdate">
                  <DateForm
                    isDisabled={false}
                    value={fromDate}
                    onChange={(e) =>
                      handleEvents(EventTarget.FromDateOnChange, e)
                    }
                    placeholder="YYYY-MM-DD"
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-3 col-md-3 col-xs-12 mb-2">
            <div className="form-group">
              <label>To Date</label>
              <br />
              <div className="">
                <div className="input-group date selectdate">
                  <DateForm
                    isDisabled={false}
                    value={toDate}
                    onChange={(e) =>
                      handleEvents(EventTarget.ToDateOnChange, e)
                    }
                    placeholder="YYYY-MM-DD"
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="col-lg-3 col-md-3 col-xs-12 pt-2 mt-4 dwnl">
            <div className="form-group">
              <Tooltip title="Export to excel" style={{ cursor: "pointer" }}>
                <button
                  className="btn btn-submit"
                  onClick={() => {
                    handleEvents(EventTarget.ExportToExcelClick);
                  }}
                >
                  {/* <RiFileExcel2Fill className="excelicon" /> */}
                  <i className="fa fa-download"></i>
                </button>
              </Tooltip>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-12 col-md-12">
            <div className="float-right">
              <button
                className="btn btn-info"
                style={{ marginLeft: 5 }}
                onClick={(e) => handleEvents(EventTarget.Apply, e)}
              >
                <i className="fas fa-check"></i> Apply
              </button>
              <button
                className="btn btn-cancel"
                style={{ marginLeft: 5 }}
                onClick={(e) => handleEvents(EventTarget.Reset, e)}
              >
                <i className="fas fa-undo"></i> Reset
              </button>
            </div>
          </div>
        </div>
      </div>
      {/*--------- Grid ----------*/}
      <div className="mb-3 pt-3">
        <DynamicGrid
          options={Options}
          data={dashboardData}
          columns={GridColumns}
        />
      </div>
    </>
  );
};

export default DepositeStatementGrid;
